import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutQualificationDetailSlideout extends Layout {
    sourceCarrierQualifications: DataSource;
    tableDetails: Table;
}
